import { useEnvironment } from '@wix/yoshi-flow-editor';
import loadable from '@wix/yoshi-flow-editor/loadable';
import type { FC } from 'react';
import React, { useRef } from 'react';

import { classes, st } from './About.st.css';
import EmptyEditor from './EmptyEditor';

const Viewer = loadable(
  () => import(/* webpackChunkName: "Viewer" */ './Viewer'),
);

const AboutEditComponent = loadable(
  () =>
    import(/* webpackChunkName: "AboutEditComponent" */ './AboutEditComponent'),
);

export type AboutProps = {
  isEditMode?: boolean;
  isEmptyState?: boolean;
  setEditMode?: (value: boolean) => void;
};

export const About: FC<AboutProps> = ({
  isEditMode,
  isEmptyState,
  setEditMode,
}) => {
  const { isEditor } = useEnvironment();
  const rootRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={rootRef} className={st(classes.root)}>
      {isEditMode || isEditor ? (
        <AboutEditComponent setEditMode={setEditMode} isEditMode={isEditMode} />
      ) : isEmptyState ? (
        <EmptyEditor setEditMode={setEditMode} />
      ) : (
        <Viewer />
      )}
    </div>
  );
};
